
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Punetoganpatipulebeach() {



    const cardData =
    {
        keyword: 'Pune to Ganpatipule Beach Bus Rental Service',
        heading: 'Amruta Travels: Pune to Ganpatipule Beach Bus Rental Service',
        headingDescription: 'Amruta Travels offers Pune to Ganpatipule Beach Bus Rental Service, providing a reliable and comfortable transportation solution for your coastal getaways. Whether you are planning a family vacation, corporate retreat, or group tour, our well-maintained buses ensure a smooth and enjoyable journey to Ganpatipule. With experienced drivers, punctual service, affordable pricing, and 24/7 availability, we make your travel to Ganpatipule simple and stress-free. Choose from our range of buses, including 14-seater, 17-seater, 20-seater, and 25-seater options, to suit your group size. Book your Pune to Ganpatipule Bus with Amruta Travels and embark on a journey of comfort and relaxation!',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],
   "services": [
    {
      "name": "Pune to Ganpatipule Tempo Traveller on Rent",
      "description": "Travel in comfort to Ganpatipule with Amruta Travels' Tempo Traveller service. Our well-maintained, air-conditioned Tempo Travellers are perfect for small groups heading to the Ganpatipule temple, ensuring a smooth and enjoyable journey."
    },
    {
      "name": "Pune to Ganpatipule 14, 17, 20, 25 Seater Bus on Rent",
      "description": "Amruta Travels offers a range of buses for your trip from Pune to Ganpatipule, including 14, 17, 20, and 25-seater options. These buses are air-conditioned, spacious, and ideal for family trips, corporate outings, or religious tours."
    },
    {
      "name": "Pune to Ganpatipule Bus Tour Package",
      "description": "Book a complete Ganpatipule Bus Tour Package with Amruta Travels. Our package includes transport, driver, and all necessary arrangements, offering you a hassle-free journey to one of Maharashtra’s most revered temples."
    },
    {
      "name": "Pimpri Chinchwad to Ganpatipule Bus on Rent",
      "description": "Residents of Pimpri Chinchwad can enjoy a comfortable ride to Ganpatipule with Amruta Travels' bus rentals. Our buses are clean, air-conditioned, and spacious, ideal for family groups or corporate trips."
    },
    {
      "name": "Kharadi to Ganpatipule Bus on Rent in Pune",
      "description": "Amruta Travels offers buses for rent from Kharadi to Ganpatipule, ensuring a comfortable and safe journey to the Ganpatipule temple. Perfect for groups of all sizes, our buses come with AC and experienced drivers."
    },
    {
      "name": "Hadapsar Pune to Ganpatipule Bus On Rent in Pune",
      "description": "Book a bus from Hadapsar to Ganpatipule with Amruta Travels for a convenient, comfortable, and affordable ride. Our buses come with air-conditioning and are driven by professional drivers ensuring a smooth trip."
    },
    {
      "name": "Hinjewadi to Ganpatipule Bus Hire",
      "description": "Travel from Hinjewadi to Ganpatipule with Amruta Travels' bus hire service. Our buses are fully air-conditioned, spacious, and ideal for long-distance trips, offering maximum comfort for religious and family tours."
    },
    {
      "name": "Kondhwa to Ganpatipule Bus Hire on Rent",
      "description": "Amruta Travels offers bus hire services for those traveling from Kondhwa to Ganpatipule. Our buses are comfortable, spacious, and fully air-conditioned, perfect for family, group, or corporate tours."
    },
    {
      "name": "Bus Hire for Outstations",
      "description": "Amruta Travels offers outstation bus hire services, including trips to Ganpatipule. Whether you're traveling for a family trip or a religious pilgrimage, our buses are equipped with modern amenities to ensure a comfortable journey."
    },
    {
      "name": "Bus Hire for Ganpatipule Darshan from Pune",
      "description": "Book a bus for your Ganpatipule Darshan trip with Amruta Travels. Our buses provide comfortable seating, air conditioning, and reliable service, making your religious tour from Pune to Ganpatipule smooth and enjoyable."
    }
  ],
  "tableData": [
    ["Pune to Ganpatipule Tempo Traveller on Rent", "Pune to Ganpatipule 14, 17, 20, 25 Seater Bus on Rent"],
    ["Pune to Ganpatipule Bus Tour Package", "Pimpri Chinchwad to Ganpatipule Bus on Rent"],
    ["Kharadi to Ganpatipule Bus on Rent in Pune", "Hadapsar Pune to Ganpatipule Bus On Rent in Pune"],
    ["Hinjewadi to Ganpatipule Bus Hire", "Kondhwa to Ganpatipule Bus Hire on Rent"],
    ["Bus Hire for Outstations", "Bus Hire for Ganpatipule Darshan from Pune"]
  ],



"whychoose": [
  {
    "WhyChooseheading": "Relaxing and Comfortable Travel to Ganpatipule Beach",
    "WhyChoosedescription": "Amruta Travels offers Pune to Ganpatipule Beach Bus Rental Service, ensuring a relaxing and comfortable journey to one of the most serene beach destinations in Maharashtra. Enjoy air-conditioned buses with spacious seating and a smooth ride."
  },
  {
    "WhyChooseheading": "Ideal for Group Trips, Family Outings, and Religious Tours",
    "WhyChoosedescription": "Whether you're planning a family getaway, a corporate retreat, or a pilgrimage tour to the famous Ganapati Temple, our buses provide the perfect transportation solution for your group."
  },
  {
    "WhyChooseheading": "Professional Drivers with Knowledge of the Route",
    "WhyChoosedescription": "Our drivers are highly experienced and familiar with the Pune to Ganpatipule route. They ensure a safe, timely, and smooth journey, allowing you to relax and enjoy the trip."
  },
  {
    "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
    "WhyChoosedescription": "Amruta Travels offers competitive and affordable pricing for Pune to Ganpatipule Beach Bus Rental Service. With no hidden charges, we ensure you have a transparent and budget-friendly travel experience."
  },
  {
    "WhyChooseheading": "Clean, Well-Maintained, and Hygienic Buses",
    "WhyChoosedescription": "Our buses are regularly serviced and thoroughly cleaned to ensure maximum comfort and hygiene for your group. We prioritize your health and comfort, especially during long journeys."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-off Locations",
    "WhyChoosedescription": "We offer flexible pick-up and drop-off options from various locations in Pune. Whether you're coming from home, your hotel, or a corporate office, we accommodate your group’s preferences."
  },
  {
    "WhyChooseheading": "Customizable Itineraries to Suit Your Needs",
    "WhyChoosedescription": "We provide customizable itineraries to make your trip to Ganpatipule Beach memorable. Whether you want to visit specific spots along the way or extend your stay, we tailor the trip to suit your schedule."
  },
  {
    "WhyChooseheading": "Simple Booking Process with Dedicated Support",
    "WhyChoosedescription": "Booking your Pune to Ganpatipule Beach Bus Rental is quick and easy with Amruta Travels. Our customer support team is always ready to assist with booking, planning, and any other requirements to ensure a smooth experience."
  }
]



































    }

const faqData = [
  {
    question: 'How can I rent a bus for a trip from Pune to Ganpatipule Beach?',
    answer: 'Renting a bus for your trip from Pune to Ganpatipule Beach with Amruta Travels is simple. You can book online, call our support team, or visit our office. We’ll help you choose the right bus based on your group size and preferences.',
  },
  {
    question: 'What types of buses are available for the Pune to Ganpatipule Beach trip?',
    answer: 'We offer a variety of buses, including 32, 35, 45, and 50-seater options. Whether you need a standard or luxury bus, we have vehicles to fit your group and ensure comfort and safety on your journey to Ganpatipule Beach.',
  },
  {
    question: 'How long does it take to travel from Pune to Ganpatipule Beach?',
    answer: 'The travel time from Pune to Ganpatipule Beach is approximately 5 to 6 hours, depending on traffic conditions. Our experienced drivers ensure a smooth and efficient journey to make the trip as comfortable as possible.',
  },
  {
    question: 'Are the buses comfortable for the long journey to Ganpatipule Beach?',
    answer: 'Yes, all our buses are well-maintained and come with comfortable seating, air conditioning, and spacious interiors. You will have a relaxing ride throughout your journey to Ganpatipule Beach.',
  },
  {
    question: 'Can I book a bus for a one-day trip to Ganpatipule Beach?',
    answer: 'Yes, we offer flexible booking options for both one-day and multi-day trips to Ganpatipule Beach. We’ll customize the itinerary based on your travel preferences and ensure that you have an enjoyable trip.',
  },
  {
    question: 'Do you provide both standard and luxury buses for the Pune to Ganpatipule trip?',
    answer: 'Yes, we offer both standard and luxury buses. Our luxury buses come with additional amenities such as premium seating, air conditioning, and more, making your journey to Ganpatipule Beach even more enjoyable.',
  },
  {
    question: 'How much does it cost to rent a bus for Pune to Ganpatipule Beach?',
    answer: 'The cost depends on factors such as the bus size, trip duration, and any additional services you may require. Please contact us for a personalized and transparent quote based on your specific travel needs.',
  },
  {
    question: 'Can I request specific pickup and drop-off locations for the trip?',
    answer: 'Yes, we offer flexible pickup and drop-off locations. Simply provide us with your desired locations, and we’ll plan the best route to suit your needs for the trip to Ganpatipule Beach.',
  },
  {
    question: 'Why choose Amruta Travels for Pune to Ganpatipule Beach bus rental?',
    answer: 'Amruta Travels offers reliable, comfortable, and timely bus services for your trip to Ganpatipule Beach. Our buses are well-maintained, and our experienced drivers ensure a safe and smooth journey. We prioritize customer satisfaction and ensure that your trip is hassle-free and enjoyable.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Sunil Shah',
    role: 'Corporate Travel Manager, Pune',
    text: 'We rented a 45-seater bus from Amruta Travels for a corporate outing to Ganpatipule Beach. The bus was spacious, clean, and comfortable. The driver was friendly, and the journey was smooth. It was a perfect trip!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Patil',
    role: 'Traveler, Pune',
    text: 'Our family booked a 32-seater bus for a weekend trip to Ganpatipule Beach. The service was excellent! The bus was comfortable, air-conditioned, and had ample space for our luggage. It made our trip to the beach even more enjoyable!',
    rating: 5,
  },
];










































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ganpatipule Beach Bus Rental Service",
  "image": "https://bushireinpune.com/assets/images/pune-to-ganpatipule-bus-rental.jpg",
  "description": "Book a comfortable and affordable bus for your trip to Ganpatipule Beach from Pune. Choose from Tempo Travellers, 14, 17, 20, and 25-seater buses for a smooth and scenic journey.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4789"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4999", // Adjust the price accordingly
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-to-ganpatipule-beach-bus-rental"
  }
};








    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Pune to Ganpatipule Beach Bus Rental Service | Affordable & Comfortable Travel | Amruta Travels</title>
  <meta 
    name="description" 
    content="Book your Pune to Ganpatipule beach bus with Amruta Travels. Choose from Tempo Travellers and various bus options for a comfortable and scenic journey to Ganpatipule Beach and nearby attractions." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/25.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoganpatipulebeach;